import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import { CartProvider } from './context/CartContext';
import { DeliveryModeProvider } from './context/DeliveryModeContext';

import HomePage from './pages/HomePage';
import Browse from './pages/Browse';
import Profile from './pages/Profile';
import RestaurantDetails from './pages/RestaurantDetails';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import PaymentReturn from './pages/PaymentReturn';
import DeleteAccount from './pages/DeleteAccount';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Support from './pages/Support';
import Wallet from './pages/Wallet';
import EditProfile from './pages/EditProfile';
import ChangePassword from './pages/ChangePassword';

import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import OtpScreen from './pages/auth/OtpScreen';
import ResetPassword from './pages/auth/ResetPassword';

import BottomTabsWeb from './components/BottomTabsWeb';

const AUTH_ROUTES = [
  '/',
  '/register',
  '/forgot-password',
  '/otp',
  '/reset-password',
  '/delete-account',
  '/privacy-policy',
  '/terms',
  '/support',
];

function AppLayout() {
  const location = useLocation();

  const shouldShowBottomTabs =
    !AUTH_ROUTES.includes(location.pathname) &&
    !location.pathname.startsWith('/payment/');

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/otp" element={<OtpScreen />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/home" element={<HomePage />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/restaurant/:id" element={<RestaurantDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/payment/:result" element={<PaymentReturn />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/support" element={<Support />} />
      </Routes>

      {shouldShowBottomTabs && <BottomTabsWeb />}
    </>
  );
}

function App() {
  return (
    <Router>
      <DeliveryModeProvider>
        <CartProvider>
          <AppLayout />
        </CartProvider>
      </DeliveryModeProvider>
    </Router>
  );
}

export default App;
